import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
Vue.use(Vuex)

const vuexPersist = new VuexPersist({
    key: 'app-data',
    storage: window.sessionStorage
})
export default new Vuex.Store({
    plugins: [vuexPersist.plugin],
    state: {
        user: null,
        organization: null,
        cancelTokens: [], // axios cancel token
    },

    mutations: {
        // login the user
        login(state, token) {
            state.user = token
        },
        logout(state) {
            state.user = null;
            state.organization = null;
        },
        setOrganization(state, organization) {
            state.organization = organization
        },
        // Mark the stored user's password as changed so the dashboard gate
        // (isPasswordChanged) stops redirecting after a successful change.
        setPasswordChanged(state, value) {
            if (!state.user) return;
            const target = state.user.Data ?? state.user.data ?? state.user;
            target.passwordChanged = value;
        },
        // clear axios cancel tokens
        clearCancelTokens(state) {
            state.cancelTokens = [];
        },
        // add axios cancel tokens
        addCancelTokens(state, token) {
            state.cancelTokens.push(token);
        },

    },
    actions: {
        // clear pending requests
        cancelPendingRequests(context) {
            context.state.cancelTokens.forEach((request) => {
                if (request.cancel) {
                    request.cancel();
                }
            });
            context.commit('clearCancelTokens');
        }
    },
    // store getters
    getters: {
        isAuthenticated: state => !!state.user,
        cancelTokens: state => state.cancelTokens,
        getOrganization: state => state.organization,
        // Support legacy and new API shapes so the token is always available for subsequent requests
        getToken: state => {
            if (!state.user) return null;
            const u = state.user;
            return (
                u.Data?.accessToken ??
                u.data?.accessToken ??
                u.Data?.AccessToken ??
                u.access_token ??
                null
            );
        },
        // Extract user profile from the login response Data envelope
        getUser: state => {
            if (!state.user) return null;
            const data = state.user.Data ?? state.user.data ?? state.user;
            return {
                fullName: data.fullName ?? data.FullName ?? null,
                userName: data.userName ?? data.UserName ?? data.username ?? null,
                role: data.role ?? data.Role ?? null,
            };
        },
        // Tri-state: true = password already changed, false = must change, null = unknown.
        // Normalizes boolean/string values and supports either the "passwordChanged"
        // signal or its inverse ("mustChangePassword"). Returns null when the API
        // sends no signal so callers can decide a safe default.
        isPasswordChanged: state => {
            if (!state.user) return null;
            const u = state.user;
            const data = u.Data ?? u.data ?? u;
            const norm = (v) => {
                if (v === true || v === false) return v;
                if (typeof v === "string") {
                    if (/^(true|yes|1)$/i.test(v.trim())) return true;
                    if (/^(false|no|0)$/i.test(v.trim())) return false;
                }
                return null;
            };
            // "already changed" style flags
            const changed = norm(
                data.passwordChanged ?? data.isPasswordChanged ?? u.passwordChanged
            );
            if (changed !== null) return changed;
            // inverse "must change" style flags
            const mustChange = norm(
                data.mustChangePassword ??
                data.forcePasswordChange ??
                data.requirePasswordChange
            );
            if (mustChange !== null) return !mustChange;
            return null;
        },
    }
});
